import type { ComponentProps, ReactNode } from 'react';
import { memo } from 'react';

import { cn } from '@/shared/utils/cn';

export interface ProfileOverviewCardImageContainerProps extends Omit<
  ComponentProps<'div'>,
  'children'
> {
  isPremium?: boolean;
  children: ReactNode;
}

export const ProfileOverviewCardImageContainer = memo(
  function ProfileOverviewCardImageContainer({
    isPremium,
    children,
    className,
    ...props
  }: ProfileOverviewCardImageContainerProps) {
    return (
      <div
        className={cn(
          'border-titan-900 relative flex min-h-0 w-full flex-col overflow-hidden rounded-xl border',
          isPremium &&
            'shadow-[0_0_4px_1px_var(--color-yellow-400)] shadow-yellow-400/80',
          className,
        )}
        {...props}
      >
        {children}
      </div>
    );
  },
);
